import { Box } from "@material-ui/core";
import React, { useContext } from "react";
import { useLocation } from "react-router";
import { Header } from "ui/componentes";
import { LoggedUserContext } from "ui/componentes/LoggedUserContext";
import { Message } from "ui/componentes/Message";

const routesToIgnoreLayout = ["/sign-in", "/auth/forgetPassword"];

const Layout = ({ children }) => {
    const loggedUser = useContext(LoggedUserContext);
    const pathName = useLocation().pathname;

    if (routesToIgnoreLayout.includes(pathName)) {
        return children;
    }

    return (
        <Box
            id="app_layout"
            display="flex"
            flexDirection="column"
            flexWrap="nowrap"
            width="100%"
            height="100vh"
            bgcolor="#F5F5F5"
            overflow="auto"
        >
            <Header />
            <Box display="flex" justifyContent="center" padding={1}>
                <Message
                    show={
                        !!loggedUser.privateInfo.tempPassword &&
                        pathName !== "/auth/resetMethods"
                    }
                    variant="warning"
                    message="Você está usando uma senha temporária, para sua segurança solicite a alteração de senha. Acesse seu Perfil e selecione o menu Senha!"
                />
            </Box>
            <Box id="app_layout_content" padding={1}>
                {children}
            </Box>
        </Box>
    );
};

export { Layout };
